/// <amd-module name="Environments/RemoteClients/Deployment" />
/**
 * ---------------------------------------------------------
 * Generated file, DO NOT EDIT
 * ---------------------------------------------------------
 *
 * See following wiki page for instructions on how to regenerate:
 *   https://aka.ms/azure-devops-client-generation
 *
 * Configuration file:
 *   tfs\web\extensions\environments\vss-environments-web\clients\genclient.json
 */

import { IVssPageContext, IVssRestClient, IVssRestClientOptions, RestClients } from "VSS/Platform/Context";
import { RestClientBase } from "VSS/Platform/RestClientBase";

import * as Deployment from "./Contracts/Deployment";

export interface IDeploymentRestClient extends IVssRestClient {
    /**
     * @param resourceUri - 
     * @param typeFilters - 
     */
    getArtifactProvenances(resourceUri: string[], typeFilters?: string): Promise<Deployment.ArtifactProvenance[]>;
}

class DeploymentRestClient extends RestClientBase implements IDeploymentRestClient {
    constructor(options: IVssRestClientOptions) {
        super(options);
    }

    /**
     * @param resourceUri - 
     * @param typeFilters - 
     */
    public async getArtifactProvenances(
        resourceUri: string[],
        typeFilters?: string
        ): Promise<Deployment.ArtifactProvenance[]> {

        const queryValues: any = {
            resourceUri: resourceUri && resourceUri.join(","),
            typeFilters: typeFilters
        };

        return this.beginRequest<Deployment.ArtifactProvenance[]>({
            apiVersion: "5.2-preview.1",
            routeTemplate: "_apis/Deployment/v1/artifactprovenances",
            queryParams: queryValues
        });
    }

}

export const DeploymentClientName = "IDeploymentRestClient";

export function getDeploymentClient(pageContext: IVssPageContext, options?: IVssRestClientOptions): IDeploymentRestClient {
    return pageContext.getRestClient<IDeploymentRestClient>(DeploymentClientName, options);
}

RestClients.add(DeploymentClientName, { 
    factory: DeploymentRestClient,
    options: {
        resourceAreaId: "8580c551-69db-4092-9050-c9ccd4521d2e",
        serviceInstanceType: "00025394-6065-48ca-87d9-7f5672854ef7"
    }
});
